<div class="block" [ngClass]="field.extraClass">
  <label>{{field.label}}<span class="required" *ngIf="field.required"> *</span></label>
  <textarea [value]="value" [placeholder]="field.placeholder" [disabled]="disabled"
    (input)="onChange($any($event.target).value)" (blur)="onTouched()" [rows]="field.rows"></textarea>
  <small class="error" *ngIf="errorMessage">
    {{ errorMessage }}
  </small>
</div>